import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { DadosEmpresaRow } from 'src/modules/serasa/serasa.pj.types'

export type ContatosProps = {
    empresa: DadosEmpresaRow
}

export default function Contatos({ empresa }: ContatosProps) {
    return (
        <>
            <Divider textAlign="center">Contatos</Divider>
            {empresa.contatos && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <GridItem label="Telefone" value={empresa.contatos.telefone} xs={6} />
                    <GridItem label="Fax" value={empresa.contatos.fax} xs={6} />
                    <GridItem label="Home Page" value={empresa.contatos.home_page} xs={12} />
                </Grid>
            )}
        </>
    )
}
